<template>
  <div class="sureOrder-wrap">
    <!-- 顶部商品logo及商品名称 -->
    <div class="shop-con">
      <div class="shop-img">
        <img :src="this.$route.query.shopLogo" alt="" />
      </div>
      <div class="shop-nick">{{ shopNick }}的店铺</div>
    </div>
    <!-- 商品订单 -->
    <div class="shop-order">
      <!-- 商品订单图片 -->
      <img class="order-img" :src="shopList.thumbnail" alt="" />
      <!-- 商品订单名称价格 -->
      <div class="order-title-price">
        <div class="order-title">{{ shopList.title }}</div>
        <div class="order-price">
          <div class="pay-before">￥</div>
          <div class="goods-price">{{ shopList.promotionPrice }}</div>
        </div>
      </div>
    </div>
    <!-- 绑定的用户手机号 -->
    <div class="bind-phone">
      <div class="phone-con">
        <div class="phone-con-text">绑定手机号</div>
        <div class="phone-con-num">{{ userPhone }}</div>
      </div>
      <!-- 提示 -->
      <div class="phone-con-tips">
        <img src="../../assets/images/icon-xinghao@2x.png" alt="" />
        <span>默认微信绑定手机号，不可修改，绑定手机号可享受购买后的权益</span>
      </div>
    </div>
    <!-- 选择支付的方式 -->
    <div class="pay-check">
      <div class="offline-way">支付方式</div>
      <div class="offline-pay">线下支付</div>
      <!-- <div class="pay-text">选择支付方式</div> -->
      <!-- 自己微信支付 -->
      <!-- <div class="mine-pay" v-if="isIos ? iosFastWXPay ? true:false:true">
                <div class="mine-pay-con">
                    <div class="mine-pay-img">
                        <img src="../../assets/images/icon-weixinzhifu@2x.png" alt="">
                    </div>
                    <div class="mine-pay-text">自己微信支付</div>
                </div>
                <div class="check-img" @click="changePayCheck">
                    <img v-if="payselect==true" style="width:20px;height:20px;"
                         src="../../assets/images/icon-xuanzhong@2x.png" alt="">
                    <img v-else style="width:20px;height:20px;" src="../../assets/images/icon-weixuanzhong@2x.png"
                         alt="">
                </div>
            </div> -->
      <!-- 找朋友代付-当面扫码支付 -->
      <!-- <div class="friend-pay" v-if="isIos ? iosFastPrePay ? true:false:true">
                <div class="friend-pay-con">
                    <div class="friend-pay-img">
                        <img src="../../assets/images/icon-erweima@2x.png" alt="">
                    </div>
                    <div class="friend-pay-text">找朋友代付-当面扫码支付</div>
                </div>
                <div class="check2-img" @click="changePayCheck2">
                    <img v-if="payselect==false" style="width:20px;height:20px;"
                         src="../../assets/images/icon-xuanzhong@2x.png" alt="">
                    <img v-else style="width:20px;height:20px;" src="../../assets/images/icon-weixuanzhong@2x.png"
                         alt="">
                </div>
            </div> -->
    </div>
    <!-- 购买须知 -->
    <div class="purchase-instructions">购买须知</div>
    <!-- <div class="purchase-instructions-con">
            您购买的课程为在线观看的数字化商品，根据《消费者权益保护法》规定，不支持七日无理由退货，请您于购买时谨慎考虑，一旦您点击确认购买，即视为您同意本条规定。
        </div> -->
    <div class="purchase-instructions-con">
      <p>
        1、您购买的课程为在线观看的数字化商品，根据《消费者权益保护法》规定，不支持七日无理由退货，请您于购买时谨慎考虑，一旦您点击确认购买，即视为您同意本条规定。
      </p>
      <p>2、该商品的交易不通过本平台，线下交易请注意资金安全。</p>
    </div>
		<div class="submit-order" @click="submitOrder">
			提交订单
		</div>
    <!-- 实付款 -->
    <!-- <div class="actual-pay">
      <div class="pay-con">
        <div class="actual-pay-text">实付:</div>
        <div class="actual-pay-money">
          <div class="actual-pay-before">￥</div>
          <div class="actual-pay-price">{{ payPrice }}</div>
        </div>
      </div>
      <div class="actual-pay-btn" v-if="isShowToPayBtn" @click="goToPayForMe">
        去付款
      </div>
    </div> -->
  </div>
</template>

<script>
import { List, Swipe, SwipeItem, Toast } from "vant";
import api from "../../api/api";
import utils from "../../utils/utils";
export default {
  name: "sureOrder",
  data() {
    return {
      shopId: 0,
      shopNick: "",
      userPhone: "",
      userInfo: {},
      payPrice: "",
      productId: 0,
      payselect: true,
      inviteCode: "",
      shopList: {},
      isIos: "",
      iosFastWXPay: false,
      iosFastPrePay: false,
      isShowToPayBtn: true,
      notBanClick: true,
    };
  },
  methods: {
    changePayCheck() {
      this.payselect = true;
      console.log("自己通过微信支付");
    },
    changePayCheck2() {
      this.payselect = false;
      console.log("让亲朋好友支付");
    },
    // 点击付款
    goToPayForMe() {
      if (this.payselect == true) {
        console.log("调用微信支付接口进行支付");
        //创建预付单 成功后跳转支付页面
        let params = {
          productId: this.productId,
        };
        if (this.inviteCode !== "" && this.inviteCode !== undefined) {
          params.inviteCode = this.inviteCode;
        }
        api
          .createOrderPre(params)
          .then((res) => {
            if (res.success) {
              let order = res.data;
              wx.miniProgram.navigateTo({
                url: "../../my/pay/pay?preOrderId=" + order.id,
              });
            } else {
              // console.log(res)
              if (res.status == 2) {
                wx.miniProgram.navigateTo({
                  url:
                    "../../login/wxLogin/wxLogin?productId=" +
                    this.productId +
                    "&shopId=" +
                    this.shopId,
                });
              }
            }
          })
          .catch((err) => {
            Toast("支付失败！");
          });
      } else {
        //创建预付单
        let params = {
          productId: this.productId,
        };
        if (this.inviteCode !== "" && this.inviteCode !== undefined) {
          params.inviteCode = this.inviteCode;
        }
        api
          .createOrderPre(params)
          .then((res) => {
            console.log("预付单", res.data);
            if (res.success) {
              let order = res.data;
              //跳转到去帮我付款页面
              this.$router.push({
                path: "./payForMe",
                query: {
                  preOrderId: res.data.id,
                  userName: this.userInfo.nickName,
                  userHeadImg: this.userInfo.wxAvatarUrl,
                  phone: this.userInfo.phone,
                  shopName: this.shopNick,
                  productName: this.shopList.title,
                  createTime: order.createTime,
                  expireTime: order.expireTime,
                  payPrice: this.payPrice,
                },
              });
            } else {
              // console.log(res)
              if (res.status == 2) {
                wx.miniProgram.navigateTo({
                  url:
                    "../../login/wxLogin/wxLogin?productId=" +
                    this.productId +
                    "&shopId=" +
                    this.shopId,
                });
              }
            }
          })
          .catch((err) => {
            Toast("创建订单失败！");
          });
      }
    },
    //获取用户信息
    getUserInfo() {
      api
        .getUserInfo()
        .then((res) => {
          if (res.success) {
            console.log("userInfo ", res.data);
            this.userPhone = res.data.phone;
            this.userInfo = res.data;
          }
        })
        .catch((err) => {
          return Toast(err.data);
        });
    },
    getProMsg() {
      let params = {
        shopId: this.shopId,
        productId: this.productId,
      };
      api
        .getProDetail(params)
        .then((res) => {
          if (res.success) {
            console.log("proMsg ", res.data);
            this.shopList = res.data;
            this.payPrice = res.data.promotionPrice;
          }
        })
        .catch((err) => {
          return Toast(err.data);
        });
    },
    // 获取常量
    getListConstant(flag) {
      let params = {
        name: flag,
      };
      return api
        .getListConstant(params)
        .then((res) => {
          if (res.success) {
            // console.log(res.data.content, '常量');
            if (flag == "iosFastWXPay") {
              this.iosFastWXPay = res.data.content == "true" ? true : false;
            } else {
              this.iosFastPrePay = res.data.content == "true" ? true : false;
            }
            if (this.iosFastWXPay) {
              this.payselect = true;
            } else if (this.iosFastPrePay) {
              this.payselect = false;
            } else {
              this.payselect = false;
            }
          } else {
            Toast(res.msg);
            return;
          }
        })
        .catch((err) => {
          Toast("系统异常!");
        });
    },
		// 提交订单
		submitOrder(){
      let params = {
        productId: this.productId,
      };
      if (this.inviteCode !== "" && this.inviteCode !== undefined) {
        params.inviteCode = this.inviteCode;
      }
      if(this.notBanClick){
        this.$toast.loading({
          message: '提交中',
          overlay: true,
          forbidClick: true
        });
        this.notBanClick = false;
        api.submitOfflineOrder(params).then(res=>{
          this.$toast.clear();
          if(res.success){
            let that = this;
            this.$toast.success({
              message: '提交成功!',
              duration: 1000,
              onClose(){
                that.$router.replace({
                  path: '/orderDetails',
                  query: {
                    orderId: res.data.orderId
                  }
                });
                that.notBanClick = true;
              }
            });
          }else{
            Toast.fail({
              message: '提交失败!',
              duration: 1000
            });
          }
        }).catch((err) => {
          Toast("系统异常!");
        });;
      }
      
		}
  },
  created() {
    document.title = "确认订单";
    this.shopNick = this.$route.query.shopName;
    this.productId = this.$route.query.productId;
    this.shopId = this.$route.query.shopId;
    if (this.$route.query.inviteCode !== undefined) {
      this.inviteCode = this.$route.query.inviteCode;
    }
    this.getUserInfo();
    this.getProMsg();
  },
  mounted() {
    if (utils.isAndroid()) {
      this.isIos = false; //android
    } else {
      this.isIos = true; //ios
      this.payselect = false;
      const that = this;
      Promise.all([
        that.getListConstant("iosFastWXPay"),
        that.getListConstant("iosFastPrePay"),
      ]).then(() => {
        console.log(that.iosFastWXPay, that.iosFastPrePay);
        if (that.iosFastWXPay == false && that.iosFastPrePay == false) {
          that.isShowToPayBtn = false;
        }
      });
    }
  },
};
</script>
<style lang="scss" scoped>
body {
  margin: 0 !important;
  padding: 0 !important;
}

.sureOrder-wrap {
  width: 100%;
  height: 100vh;
  background: #f8f8f8;
  //   顶部商品logo及商品名称
  .shop-con {
    width: 100%;
    height: 53px;
    display: flex;
    align-items: center;

    .shop-img {
      width: 25px;
      height: 25px;
      margin-left: 20px;

      img {
        width: 25px;
        height: 25px;
        border-radius: 12.5px;
      }
    }

    .shop-nick {
      width: 280px;
      height: 20px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      margin-left: 8px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  //   商品订单
  .shop-order {
    width: 100%;
    height: 103px;
    background: #ffffff;
    border-radius: 10px;
    display: flex;
    //   商品订单图片
    .order-img {
      display: inline-block;
      width: 100px;
      height: 75px;
      background: #ffffff;
      border-radius: 4px;
      margin-top: 15px;
      margin-left: 20px;
    }

    //商品订单名称价格
    .order-title-price {
      width: 217px;
      height: 75px;
      margin-top: 15px;
      margin-left: 16px;

      .order-title {
        width: 217px;
        height: 44px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        text-align: left;
      }

      .order-price {
        width: 100px;
        height: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        display: flex;
        align-items: center;

        .pay-before {
          width: 12px;
          height: 12px;
          margin-right: 4px;
          color: #ff5534;
        }

        .goods-price {
          width: 66px;
          height: 28px;
          font-weight: 500;
          color: #ff5534;
          line-height: 28px;
          margin-top: 8px;
          font-size: 20px;
          text-align: left;
        }
      }
    }
  }

  //   绑定的用户手机号
  .bind-phone {
    height: 98px;
    .phone-con {
      // width: 100%;
      height: 25px;
      padding: 14px 20px 9px 20px;
      display: flex;
      justify-content: space-between;
      .phone-con-text {
        width: 80px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        padding-top: 2px;
      }

      .phone-con-num {
        // width: 115px;
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #333333;
        line-height: 25px;
      }
    }

    // 提示
    .phone-con-tips {
      // width: 355px;
      // height: 34px;
      font-size: 12px;
      padding-left: 20px;
      padding-right: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ac692d;
      line-height: 17px;
      text-align-last: left;
      padding-bottom: 14px;
      img {
        width: 7px;
        height: 7px;
        margin-right: 7px;
        margin-bottom: 2px;
      }
    }
  }
  .bind-phone,
  .pay-check {
    width: 100%;
    margin-top: 14px;
    background: #ffffff;
    border-radius: 8px;
  }
  // 选择支付的方式
  .pay-check {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 18px;
    border-radius: 8px;
    .offline-way {
      color: #666;
    }
    .offline-pay {
      color: #333330;
    }
    .pay-text {
      width: 84px;
      height: 16px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 16px;
      padding-top: 14px;
      padding-left: 20px;
    }

    // 自己微信支付
    .mine-pay {
      margin: 20px 22px 0 20px;
      height: 27px;
      display: flex;
      justify-content: space-between;
      .mine-pay-con {
        display: flex;
        align-items: center;
      }
      .mine-pay-img {
        position: relative;
        top: 2px;
        width: 27px;
        height: 27px;
        img {
          width: 27px;
          height: 27px;
        }
      }

      .mine-pay-text {
        width: 268px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        margin-left: 8px;
        margin-top: 3px;
        text-align-last: left;
      }

      .check-img {
        width: 20px;
        height: 20px;
        margin: 2px;
      }
    }

    //   找朋友代付-当面扫码支付
    .friend-pay {
      margin: 20px 22px 0px 20px;
      height: 27px;
      display: flex;
      justify-content: space-between;
      .friend-pay-con {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .friend-pay-img {
          width: 27px;
          height: 27px;
          img {
            width: 27px;
            height: 27px;
          }
        }
        .friend-pay-text {
          width: 268px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          margin-top: 3px;
          margin-left: 8px;
          text-align-last: left;
        }
      }

      .check2-img {
        width: 20px;
        height: 20px;
        margin: 2px;
      }
    }
  }

  //购买须知
  .purchase-instructions {
    width: 48px;
    height: 16px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
    margin: 18px 0px 7px 20px;
  }

  .purchase-instructions-con {
    // height: 80px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    line-height: 20px;
    text-align: left;
    padding: 0px 20px;
    margin: 0 auto;
    p {
      margin: 0;
    }
  }
  //    实付款
  .actual-pay {
    width: 100%;
    height: 50px;
    background: #ffffff;
    box-shadow: 0px -1px 0px 0px #f1f3f4;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0px;
    left: 0px;
    .pay-con {
      display: flex;
      align-items: center;
      .actual-pay-text {
        width: 37px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        margin-left: 20px;
      }

      .actual-pay-money {
        display: flex;
        .actual-pay-before {
          width: 13px;
          height: 13px;
          color: #ff3d15;
          margin-top: 5px;
          margin-right: 6px;
        }

        .actual-pay-price {
          width: 44px;
          height: 33px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ff3d15;
          line-height: 33px;
        }
      }
    }

    .actual-pay-btn {
      width: 140px;
      height: 40px;
      line-height: 40px;
      background: #ff6060;
      border-radius: 23px;
      margin-right: 23px;
      line-height: 40px;
      color: #ffffff;
      font-weight: bold;
    }
  }

	// 提交订单按钮
	.submit-order{
		position: fixed;
		left: 10%;
		bottom: 5%;
		width: 80%;
		height: 48px;
		margin: 3rem auto 0;
		line-height: 48px;
		background: linear-gradient(315deg, #FF6060 0%, #FB6460 100%);
		border-radius: 25px;
		text-align: center;
		font-weight: 500;
		color: #fff;
	}
}
</style>
